module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/middle_selected.659c5da5.gif";